import { Method, send } from './MyHttp';

/**
 * 정보
 */
export const Get = (device_no, date, success, fail) => {
    let paramsT = {};

    send(Method.GET, `/deviceData/${device_no}/${date}`, paramsT, success, fail);
};

/**
 * 시간 구간 이력
 * @param {number|string} device_no
 * @param {string} start_date
 * @param {string} end_date
 * @param {object|function} paramsOrSuccess size 등 query 또는 success 콜백(하위호환)
 * @param {function} [success]
 * @param {function} [fail]
 */
export const GetTime = (device_no, start_date, end_date, paramsOrSuccess, success, fail) => {
    let paramsT = {};
    let ok = success;
    let ng = fail;

    if (typeof paramsOrSuccess === 'function') {
        ok = paramsOrSuccess;
        ng = success;
    } else if (paramsOrSuccess && typeof paramsOrSuccess === 'object') {
        paramsT = { ...paramsOrSuccess };
    }

    send(Method.GET, `/deviceData/${device_no}/${start_date}/${end_date}`, paramsT, ok, ng);
};

/**
 * 리스트
 */
export const GetList = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, '/deviceData', paramsT, success, fail);
};

/**
 * 리스트 (마지막 데이터)
 */
export const GetListLast = (params, success, fail) => {
    let paramsT = { ...params };

    send(Method.GET, '/deviceData/last', paramsT, success, fail);
};

/**
 * 현재 점유 세션 사용시간
 * GET /deviceData/usage?device_no=
 */
export const GetUsage = (params, success, fail) => {
    const device_no = typeof params === 'object' ? params.device_no ?? params.id : params;
    send(Method.GET, '/deviceData/usage', { device_no, id: device_no }, success, fail);
};
